import { OverrideBehaviorSetting } from '@api/generated/graphql';
import { getGlobalRecordingOverrideSettings } from '@api/queries/recording/queries';
import { useQuery } from '@apollo/client/react';
import { FeatureFlagKeys, useFeatureFlags } from '@modules/FeatureFlagModule';

export const useGlobalRecordingOverride = () => {
  const {
    [FeatureFlagKeys.featureGlobalRecordingOverridesEnabled]:
      featureGlobalRecordingOverridesEnabled,
  } = useFeatureFlags();

  const { data } = useQuery(getGlobalRecordingOverrideSettings, {
    skip: !featureGlobalRecordingOverridesEnabled,
  });

  const overrideBehavior =
    data?.globalRecordingOverrideSettings?.overrideBehavior;
  const isGlobalOverrideEnabled =
    overrideBehavior === OverrideBehaviorSetting.OnCallConnected;

  return { isGlobalOverrideEnabled };
};
